import { AnyAction, combineReducers, createStore, Reducer } from 'redux';
import { FormStateMap, reducer as formReducer } from 'redux-form';

import { RootState } from '../../RootState';
import faqPageReducer from '../FaqPage/faqPageDuck';
import localizationReducer from '../Localization/localizationDuck';
import navReducer from '../Nav/navDuck';

const rootReducer = combineReducers<RootState>({
  form: formReducer as Reducer<FormStateMap, AnyAction>,
  faqPage: faqPageReducer,
  localization: localizationReducer,
  nav: navReducer,
});

export default createStore(rootReducer);



// WEBPACK FOOTER //
// /www/client/src/containers/App/store.ts